import API from '@retisio/api';
export const ConfigService = {
  getApplications(){
    return API.get(`/api/rbac/api/v1/applications`);
  }
};
